import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Marathons(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Марафоны
      </Typography.Title>
      <List />
    </div>
  );
}
